export default __webpack_public_path__ + "static/media/bg-masthead-2.697c631e.webp";